import SecondLevelItems from './SecondLevelItems.jsx';

export default function NavigationLayerHidden({secondLevelNavigationItems}) {
    const filteredSubNavigationItems = secondLevelNavigationItems.filter((item) => !item.overviewItem);
    const activeItem = filteredSubNavigationItems.filter((item) => item.active)[0] || filteredSubNavigationItems[0];

    return (
        <div className="navigation__layer" style={{visibility: 'hidden', pointerEvents: 'none', width: '0px'}}>
            <SecondLevelItems
                secondLevelNavigationItems={secondLevelNavigationItems}
                currentHoveredItemId={activeItem?.id}
                thirdLevelEmpty={true}
                disableFocusTrap={true}
            />
        </div>
    );
}
